import { PortalUserToken } from 'helpers/api';
import swal from 'sweetalert';
import { isProd } from 'config/config';

import Vue from 'vue/dist/vue';

const partSmartSuccessUrl = isProd ? `/portal` : '/dashboard.html';

const partSmartEl = document.querySelector('#partSmart');

if (partSmartEl) {
    new Vue({
        el: '#partSmart',
        data: {
            res: null,
            isLoading: true
        },

        methods: {
            async setValues() {
                // Get PartSmart Portal User Token
                const portalUserToken = await PortalUserToken();
                this.res = portalUserToken.data;

                var psScript = document.createElement('script');
                psScript.type = 'text/javascript';
                psScript.async = true;
                psScript.src = 'https://www.partsmart.net:443/stream.js?access_token=' + this.res.access_token + '&refresh_token=' + this.res.refresh_token + '&expires_in=' + this.res.expires_in;
                document.getElementById('partSmart').appendChild(psScript);

                this.isLoading = false;
            },
        },
        created() {
            this.setValues();
        },
    });
}

async function init() { }


export default init;


// WEBPACK FOOTER //
// ./app/js/modules/partSmart.js